import { render, staticRenderFns } from "./AddSalesDeliveryPage.vue?vue&type=template&id=1d254da6"
import script from "./AddSalesDeliveryPage.vue?vue&type=script&lang=js"
export * from "./AddSalesDeliveryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports